__turbopack_context__.v({
  "black-bt": "mygoodcause-module-scss-module__pekoya__black-bt",
  "bottomParagraph": "mygoodcause-module-scss-module__pekoya__bottomParagraph",
  "btnCustom": "mygoodcause-module-scss-module__pekoya__btnCustom",
  "clickHere": "mygoodcause-module-scss-module__pekoya__clickHere",
  "goodCauseImage": "mygoodcause-module-scss-module__pekoya__goodCauseImage",
  "heading": "mygoodcause-module-scss-module__pekoya__heading",
  "image": "mygoodcause-module-scss-module__pekoya__image",
  "messageGood": "mygoodcause-module-scss-module__pekoya__messageGood",
  "myGoodCause": "mygoodcause-module-scss-module__pekoya__myGoodCause",
  "myGoodCauseForm": "mygoodcause-module-scss-module__pekoya__myGoodCauseForm",
  "myGoodCausePg": "mygoodcause-module-scss-module__pekoya__myGoodCausePg",
  "myGoodCausePgHeader": "mygoodcause-module-scss-module__pekoya__myGoodCausePgHeader",
  "newbtnDesign": "mygoodcause-module-scss-module__pekoya__newbtnDesign",
  "paragraph": "mygoodcause-module-scss-module__pekoya__paragraph",
  "removePTMgBottom": "mygoodcause-module-scss-module__pekoya__removePTMgBottom",
  "selectBoxGoodCause": "mygoodcause-module-scss-module__pekoya__selectBoxGoodCause",
  "selectSmallText": "mygoodcause-module-scss-module__pekoya__selectSmallText",
  "select__control": "mygoodcause-module-scss-module__pekoya__select__control",
  "text-danger": "mygoodcause-module-scss-module__pekoya__text-danger",
  "textDanger": "mygoodcause-module-scss-module__pekoya__textDanger",
});
